<ng-container *ngIf="airSegmentSearchForm">
    <ng-container>
        <h2 *ngIf="wayType === eWayType.Oneway " class="form-title">{{ wording.oneWay }}</h2>
        <h2 *ngIf="wayType === eWayType.Return" class="form-title">{{ wording.return }}</h2>
    </ng-container>

    <form [formGroup]="airSegmentSearchForm" class="field-flex">
        <airport-select
                [tabindex]="0"
                [direction]="'from'"
                [firstLocationCode]="airSegmentSearchForm.get([0, eSegmentFields.from]).value"
                [firstIsAirportOnly]="airSegmentSearchForm.get([0, eSegmentFields.isFromAirport]).value"
                (onChooseLocation)="patchSegment($event, eSegmentFields.from)"
        ></airport-select>
        <airport-select
                [tabindex]="1"
                [direction]="'to'"
                [firstLocationCode]="airSegmentSearchForm.get([0, eSegmentFields.to]).value"
                [firstIsAirportOnly]="airSegmentSearchForm.get([0, eSegmentFields.isToAirport]).value"
                (onChooseLocation)="patchSegment($event, eSegmentFields.to)"
        ></airport-select>
        <date-field
                [onlyOneMonth]="onlyOneMonth"
                [fieldConfig]="{formGroup: airSegmentSearchForm.get([0]),
                                     formControlName: 'begin',
                                     minDate: today,
                                     defaultDate: today,
                                     placeholder: wayType === eWayType.Oneway ? wording.date : wording.dateBegin,
                                     validators: dateValidator}"></date-field>
        <date-field #returnDate *ngIf="wayType === eWayType.Return"
                    [onlyOneMonth]="onlyOneMonth"
                    [fieldConfig]="{formGroup: airSegmentSearchForm.get([1]),
                                     formControlName: 'begin',
                                     minDate: minReturnDate,
                                     defaultDate: minReturnDate,
                                     placeholder: wording.dateEnd,
                                     validators: dateValidator}"></date-field>
    </form>
</ng-container>


